export default "__VITE_ASSET__149d4fd4__"